const env = process.env;
export const qa = env.VUE_APP_API_BASE_URL.includes('qa');
export const prod = env.VUE_APP_API_BASE_URL === 'preview.api.upcontent.com';
export const dev = window.location.hostname === 'localhost';
